import API_BASE from '../../utils/api';
import React, { useState, useEffect } from 'react';
import { useAuth } from '../../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Sidebar from '../../components/Sidebar';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
// Add this import at the top
import ProfileDropdown from '../../components/ProfileDropdown';

// Replace the nav section with this:

const TeacherLeaves = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [leaves, setLeaves] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [loading, setLoading] = useState(true);
  const [formData, setFormData] = useState({
    leaveType: 'sick',
    startDate: new Date(),
    endDate: new Date(),
    reason: ''
  });

  useEffect(() => {
    fetchLeaves();
  }, []);

  const fetchLeaves = async () => {
    try {
      const response = await axios.get(`${API_BASE}/leaves/my-leaves`);
      setLeaves(response.data);
    } catch (error) {
      console.error('Error fetching leaves:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${API_BASE}/leaves/apply`, formData);
      setShowForm(false);
      setFormData({
        leaveType: 'sick',
        startDate: new Date(),
        endDate: new Date(),
        reason: ''
      });
      fetchLeaves();
    } catch (error) {
      console.error('Error applying for leave:', error);
      alert('Error applying for leave');
    }
  };

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const getStatusBadge = (status) => {
    const colors = {
      pending: 'bg-yellow-100 text-yellow-800',
      approved: 'bg-green-100 text-green-800',
      rejected: 'bg-red-100 text-red-800'
    };
    return colors[status] || 'bg-gray-100 text-gray-800';
  };

  const getLeaveTypeIcon = (type) => {
    const icons = {
      sick: '🤒',
      casual: '😊',
      earned: '⭐',
      other: '📝'
    };
    return icons[type] || '📅';
  };

  const calculateDays = (start, end) => {
    const diff = new Date(end) - new Date(start);
    return Math.ceil(diff / (1000 * 60 * 60 * 24)) + 1;
  };

  if (loading) {
    return (
      <div className="flex">
        <Sidebar />
        <div className="flex-1 bg-gray-100 flex items-center justify-center h-screen">
          <div className="text-xl">Loading...</div>
        </div>
      </div>
    );
  }

  return (
    <div className="flex">
      <Sidebar />
      <div className="flex-1 bg-gray-100 min-h-screen">
        <nav className="bg-white shadow-sm sticky top-0 z-10">
  <div className="px-6 py-4 flex justify-between items-center">
    <h1 className="text-2xl font-semibold text-gray-800">Leave Management</h1>
    <ProfileDropdown />
  </div>
</nav>

        <div className="p-6">
          {/* Apply Leave Button */}
          <div className="bg-white rounded-lg shadow p-6 mb-6">
            <button
              onClick={() => setShowForm(!showForm)}
              className="bg-indigo-600 text-white px-6 py-3 rounded-lg hover:bg-indigo-700 flex items-center space-x-2"
            >
              <span>{showForm ? '✕' : '+'}</span>
              <span>{showForm ? 'Cancel' : 'Apply for Leave'}</span>
            </button>
          </div>

          {/* Leave Application Form */}
          {showForm && (
            <div className="bg-white rounded-lg shadow p-6 mb-6">
              <h2 className="text-lg font-semibold mb-4">Apply for Leave</h2>
              <form onSubmit={handleSubmit} className="space-y-4">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Leave Type
                    </label>
                    <select
                      value={formData.leaveType}
                      onChange={(e) => setFormData({...formData, leaveType: e.target.value})}
                      className="w-full border rounded-md px-3 py-2"
                    >
                      <option value="sick">Sick Leave</option>
                      <option value="casual">Casual Leave</option>
                      <option value="earned">Earned Leave</option>
                      <option value="other">Other</option>
                    </select>
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Duration (Days)
                    </label>
                    <p className="text-lg font-semibold text-indigo-600">
                      {calculateDays(formData.startDate, formData.endDate)} days
                    </p>
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Start Date
                    </label>
                    <DatePicker
                      selected={formData.startDate}
                      onChange={(date) => setFormData({...formData, startDate: date})}
                      className="w-full border rounded-md px-3 py-2"
                      dateFormat="yyyy-MM-dd"
                      minDate={new Date()}
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      End Date
                    </label>
                    <DatePicker
                      selected={formData.endDate}
                      onChange={(date) => setFormData({...formData, endDate: date})}
                      className="w-full border rounded-md px-3 py-2"
                      dateFormat="yyyy-MM-dd"
                      minDate={formData.startDate}
                    />
                  </div>

                  <div className="md:col-span-2">
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Reason
                    </label>
                    <textarea
                      value={formData.reason}
                      onChange={(e) => setFormData({...formData, reason: e.target.value})}
                      rows="3"
                      className="w-full border rounded-md px-3 py-2"
                      required
                    />
                  </div>
                </div>

                <div className="flex justify-end">
                  <button
                    type="submit"
                    className="bg-indigo-600 text-white px-6 py-2 rounded hover:bg-indigo-700"
                  >
                    Submit Request
                  </button>
                </div>
              </form>
            </div>
          )}

          {/* Leave History */}
          <div className="bg-white rounded-lg shadow overflow-hidden">
            <div className="px-6 py-4 bg-indigo-600 text-white">
              <h2 className="text-lg font-semibold">Leave History</h2>
            </div>
            
            {leaves.length === 0 ? (
              <div className="p-12 text-center">
                <span className="text-6xl mb-4 block">📭</span>
                <p className="text-gray-500">No leave applications found</p>
              </div>
            ) : (
              <div className="divide-y divide-gray-200">
                {leaves.map((leave) => (
                  <div key={leave._id} className="p-6 hover:bg-gray-50">
                    <div className="flex items-start justify-between">
                      <div className="flex items-start space-x-4">
                        <span className="text-3xl">{getLeaveTypeIcon(leave.leaveType)}</span>
                        <div>
                          <h3 className="font-semibold capitalize">{leave.leaveType} Leave</h3>
                          <p className="text-sm text-gray-500">
                            {new Date(leave.startDate).toLocaleDateString()} - {new Date(leave.endDate).toLocaleDateString()}
                          </p>
                          <p className="text-sm text-gray-600 mt-2">{leave.reason}</p>
                          <p className="text-xs text-gray-400 mt-2">
                            Applied on: {new Date(leave.createdAt).toLocaleDateString()}
                          </p>
                        </div>
                      </div>
                      <div className="text-right">
                        <span className={`px-3 py-1 rounded-full text-xs font-semibold ${getStatusBadge(leave.status)}`}>
                          {leave.status}
                        </span>
                        {leave.remarks && (
                          <p className="text-xs text-gray-500 mt-2">Remarks: {leave.remarks}</p>
                        )}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TeacherLeaves;